/**
 * Bytes <-> base64 — the one place this client's wire format needs it. `System.Text.Json`'s
 * own convention for a C# `byte[]` property is a base64 string, so
 * `AssistantAudioChunkUpdate.data` and `AssistantReplyDto.audio` both travel this way rather
 * than as a packed number array the way `packing.ts` handles `Vec3`/`Quat`: there is no
 * fixed element width to exploit for a byte, so there is nothing packing would buy over the
 * format the server already expects.
 */

/**
 * `String.fromCharCode(...bytes)` in one call blows the call stack once `bytes` is large
 * enough — plausible for an assistant clip built up over several seconds of chunks — so
 * this builds the binary string in fixed-size slices instead.
 */
const CHUNK_SIZE = 0x8000;

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';

  for (let offset = 0; offset < bytes.length; offset += CHUNK_SIZE) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + CHUNK_SIZE));
  }

  return btoa(binary);
}

export function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
}
